module.exports = __webpack_public_path__ + "static/media/uplands-bg.a8bb6131.png";